import React, { forwardRef } from 'react';
import AnimateHeight from 'react-animate-height';
import { ReactComponent as Chevron } from '../../assets/images/chevron-down.svg';
import './GuidelineNavigation.scss';

const NavigationSection = ({ section, activeSection }) => {
  const {
    title,
    id,
    children,
    startIndex,
    endIndex,
  } = section;

  const isSectionActive = activeSection >= startIndex && activeSection <= endIndex;

  const scrollToHandler = (event, sectionId) => {
    if (event) event.preventDefault();
    const targetEl = document.getElementById(sectionId);
    if (targetEl) targetEl.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <div className="navigation-section">
      <button
        type="button"
        className={`parent-link anchor-link${isSectionActive ? ' active' : ''}`}
        onClick={event => scrollToHandler(event, id)}
        aria-label={`Jump to the ${title} section`}
      >
        <span>{title}</span>
        <Chevron className="chevron" />
      </button>
      {children && children.length > 0 && (
        <AnimateHeight
          duration={300}
          height={isSectionActive ? 'auto' : 0}
        >
          <ul className="children">
            {children.map((child, index) => {
              const isActive = index + startIndex + 1 === activeSection;
              return (
                <li className="child" key={child.id}>
                  <button
                    type="button"
                    className={`child-link anchor-link${isActive ? ' active' : ''}`}
                    onClick={event => scrollToHandler(event, child.id)}
                    aria-label={`Jump to the ${child.title} section`}
                  >
                    <span>{child.title}</span>
                  </button>
                </li>
              );
            })}
          </ul>
        </AnimateHeight>
      )}
    </div>
  );
};

const GuidelineNavigation = forwardRef((props, ref) => {
  const { navigation, activeSection } = props;
  return (
    <div className="guideline-navigation" ref={ref}>
      {navigation && navigation.map(navSection => (
        <NavigationSection key={navSection.id} section={navSection} activeSection={activeSection} />
      ))}
    </div>
  );
});

GuidelineNavigation.displayName = 'GuidelineNavigation';

export default GuidelineNavigation;
